import { app } from '../../app.module'
app
  // Twitterアカウントテーブルの平均値
  .directive('accountTwitterTableAverage', () => {
    return {
      restrict: 'EA',
      template: require('./account-twitter-table-average.pug')(),
      controller: function ($scope) {
        $scope.$watch(
          () => {
            return $scope.sortAccounts
          },
          () => {
            let followersTotal = 0
            let followersPerPostTotal = 0
            let likesTotal = 0
            let likesPerPostTotal = 0
            let retweetsTotal = 0
            let impressionsTotal = 0
            let impressionsPerPostTotal = 0
            let quotesTotal = 0
            let quotesPerPostTotal = 0
            let repliesTotal = 0
            let repliesPerPostTotal = 0
            let retweetsPerPostTotal = 0
            let engagementsTotal = 0
            let engagementsPerPostTotal = 0
            let engagementRateTotal = 0
            let postCountTotal = 0

            $scope.sortAccounts.forEach(function (account) {
              followersTotal = followersTotal + account.followers
              likesTotal = likesTotal + account.likes
              retweetsTotal = retweetsTotal + account.retweets
              impressionsTotal = impressionsTotal + account.impressions
              repliesTotal = repliesTotal + account.replies
              quotesTotal = quotesTotal + account.quotes
              engagementsTotal = engagementsTotal + account.engagements
              engagementRateTotal = engagementRateTotal + account.engagementRate
              postCountTotal = postCountTotal + account.posts
              // 投稿数が0より大きい場合、1投稿あたりの平均を会計
              if (account.posts > 0) {
                followersPerPostTotal = followersPerPostTotal + account.followers / account.posts
                likesPerPostTotal = likesPerPostTotal + account.likes / account.posts
                retweetsPerPostTotal = retweetsPerPostTotal + account.retweets / account.posts
                engagementsPerPostTotal =
                  engagementsPerPostTotal + account.engagements / account.posts
                impressionsPerPostTotal =
                  impressionsPerPostTotal + account.impressions / account.posts
                quotesPerPostTotal = quotesPerPostTotal + account.quotes / account.posts
                repliesPerPostTotal = repliesPerPostTotal + account.replies / account.posts
              } else {
                followersPerPostTotal = followersPerPostTotal + account.followers
                likesPerPostTotal = likesPerPostTotal + account.likes
                retweetsPerPostTotal = retweetsPerPostTotal + account.retweets
                impressionsPerPostTotal = impressionsPerPostTotal + account.impressions
                quotesPerPostTotal = quotesPerPostTotal + account.quotes
                repliesPerPostTotal = repliesPerPostTotal + account.replies
                engagementsPerPostTotal = engagementsPerPostTotal + account.engagements
              }
            })
            // フォロワー数
            $scope.followersAverage = followersTotal / $scope.sortAccounts.length
            // いいねの平均
            $scope.likesAverage = likesTotal / $scope.sortAccounts.length
            // リポストの平均
            $scope.retweetsAverage = retweetsTotal / $scope.sortAccounts.length
            // インプレッションの平均
            $scope.impressionsAverage = impressionsTotal / $scope.sortAccounts.length
            // 引用の平均
            $scope.quotesAverage = quotesTotal / $scope.sortAccounts.length
            // 返信の平均
            $scope.repliesAverage = repliesTotal / $scope.sortAccounts.length
            // 反応数の平均
            $scope.engagementsAverage = engagementsTotal / $scope.sortAccounts.length
            // 反応率の平均
            $scope.engagementRateAverage = engagementRateTotal / $scope.sortAccounts.length
            // 投稿数の平均
            $scope.postsAverage = postCountTotal / $scope.sortAccounts.length

            // 1投稿あたりの平均
            // いいねの平均
            $scope.likesPerPostAverage = likesPerPostTotal / $scope.sortAccounts.length
            // リポストの平均
            $scope.retweetsPerPostAverage = retweetsPerPostTotal / $scope.sortAccounts.length
            // インプレッションの平均
            $scope.impressionsPerPostAverage = impressionsPerPostTotal / $scope.sortAccounts.length
            // 引用の平均
            $scope.quotesPerPostAverage = quotesPerPostTotal / $scope.sortAccounts.length
            // 返信の平均
            $scope.repliesPerPostAverage = repliesPerPostTotal / $scope.sortAccounts.length
            // 反応数の平均
            $scope.engagementsPerPostAverage = engagementsPerPostTotal / $scope.sortAccounts.length
          }
        )
      },
    }
  })
